/* SAINTE MER — shopweites Verhalten. Lag bis 09/2026 inline in snippets/mega-menu.liquid
   und ging damit dreimal pro Seite über die Leitung (einmal je Mega-Menü-Block). */
(function () {
  if (window.__smGlobalBehaviour) return;
  window.__smGlobalBehaviour = true;

  /* ---------- Video-Lightbox ---------- */
  var box = null;

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    var dying = box;
    box = null;
    setTimeout(function () {
      dying.remove();
    }, 250);
    document.documentElement.style.overflow = '';
  }

  function open(source) {
    close();

    box = document.createElement('div');
    box.className = 'sm-lightbox';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'sm-lightbox__close';
    button.setAttribute('aria-label', 'Schließen');
    button.textContent = '×';

    var video = source.cloneNode(true);
    video.removeAttribute('class');
    video.removeAttribute('style');
    video.controls = true;
    video.muted = false;
    video.loop = false;
    video.setAttribute('playsinline', '');

    box.appendChild(button);
    box.appendChild(video);
    document.body.appendChild(box);
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(function () {
      box.classList.add('is-open');
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    });

    button.addEventListener('click', close);
    box.addEventListener('click', function (event) {
      if (event.target === box) close();
    });
    video.addEventListener('ended', close);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  document.addEventListener(
    'play',
    function (event) {
      var video = event.target;
      if (!video || video.tagName !== 'VIDEO' || box) return;

      var tile = video.closest ? video.closest('[class*="product-gallery__media"]') : null;
      if (!tile) return;
      if (video.autoplay && video.muted) return;

      video.pause();
      open(video);
    },
    true
  );

  /* ---------- Farbwechsel auf der Produktseite: zur Galerie scrollen ----------
     Die Galerie ist ein 2-Spalten-Raster neben der Info-Spalte. Wer weiter unten
     eine andere Farbe wählt, sieht sonst nicht, dass die Bilder gewechselt haben.
     Greift nur bei Farb-Swatches (fieldset mit .swatch), nicht bei Größen, und
     nur wenn die Galerie-Oberkante aus dem Sichtfeld gescrollt ist.
     Kein scrollIntoView — bewusst window.scrollTo mit Header-Offset. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio') return;
    if (!input.closest) return;
    var fieldset = input.closest('fieldset');
    if (!fieldset || !fieldset.querySelector('.swatch')) return;
    if (!input.closest('.product-info')) return;

    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    setTimeout(function () {
      var rect = gallery.getBoundingClientRect();
      if (rect.top >= 0) return;
      var header = document.querySelector('store-header, .header');
      var offset = header ? header.getBoundingClientRect().height : 0;
      window.scrollTo({ top: window.scrollY + rect.top - offset - 12, behavior: 'smooth' });
    }, 250);
  });
})();
